import BackBreadcrumb from 'library/molecules/Breadcrumb/BackBreadcrumb'

export { default } from './Breadcrumb'

export { BackBreadcrumb }

export type { BreadcrumbProps } from './Breadcrumb'
export type { IPreviousPage } from './Breadcrumb'
